import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface ConfirmacionPopupProps {
    open: boolean;
    onClose: () => void;
    titulo?: string;
    mensaje?: string;
}

export default function ConfirmacionPopup({ 
    open, 
    onClose, 
    titulo = "¡Éxito!",
    mensaje = "El comprobante se cargó correctamente."
}: ConfirmacionPopupProps) {
    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogContent sx={{ textAlign: 'center', py: 4 }}>
                <Box sx={{ mb: 2 }}>
                    <CheckCircleIcon 
                        sx={{ 
                            fontSize: 64, 
                            color: 'success.main' 
                        }} 
                    />
                </Box>
                <DialogTitle sx={{ p: 0, mb: 1 }}>
                    {titulo}
                </DialogTitle>
                <Typography variant="body1" color="text.secondary">
                    {mensaje}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
                <Button 
                    variant="contained" 
                    onClick={onClose}
                    sx={{ minWidth: 120 }}
                >
                    Aceptar
                </Button>
            </DialogActions>
        </Dialog>
    );
}